import React, { Component } from 'react';
import md5 from 'blueimp-md5';
import { Cell, ActionCell } from 'components/Table';
import Reactable, {Table, Thead, Th, Tr, Td} from 'reactable';
import { VisibleOnlyAdmin, VisibleOnlyCustomer } from 'components/AuthenticatedComponent';

import { keyedObjToArr } from '../util';
import 'sass/components/user-list';

export class UserActionsCell extends Component {
	//TODO Edit User
	//TODO Send Reset Password Link
	//TODO Enable/Disable
	render () {
		return(<ActionCell {...this.props}
                           edit={this.props.editUser.bind(this)}
                           delete={this.props.deleteUser.bind(this)}
		/>);
	}
}

export class AvatarCell extends Component {
    render () {
        let name = this.props.item.name ?  this.props.item.name
            .split(' ')
            .map( (word)=> {
                return word.toUpperCase().charAt(0);
            }).join('').substring(0,1)  : '';
        let trial = this.props.item.trial ? 'trial' : '';
        return (
			<Cell {...this.props} value={this.props.value}>
				<div className={`avatar ${this.props.item.role} ${trial}`}>{name !== '' ? name : 'C'}</div>
			</Cell>
        );
    }
}

export default class UserList extends Component {

	render () {
		let users = keyedObjToArr(this.props.users);
		let isAdmin = this.props.user.role === 'admin';
		return (
			<Table
				className="table ui-list"
				sortable={['name','email','customer','role']}
				filterable={['name','email','customer','role']}
				hideFilterInput
				filterBy={this.props.filterBy}
				noDataText=" No users found"
				defaultSort='customer'
			>
				<Thead className="list-row header">
				<Th className="list-cell avatar-cell" column="status">&nbsp;</Th>
				<Th className="list-cell" column="name">Name</Th>
				<Th className="list-cell" column="email">Email</Th>
				<Th className="list-cell" column="customer" >Customer</Th>
				<Th className="list-cell" column="role">Role</Th>
				{isAdmin ? (<Th className="list-cell align-center narrow" column="edit">Edit</Th>) : (<Th column=""></Th>)}
				</Thead>
				{users.map((userItem, index) => {
                    let customer;
                    if(userItem.customer)
                    	customer = this.props.customers[userItem.customer];

                    if(!customer && this.props.customers && this.props.customers.name) {
                        customer = {};
                        customer.name = this.props.customers.name;
                    }

                    let className = userItem.disabled ? "list-cell disabled" : "list-cell";
					return (
						<Tr className="list-row" key={index}>
							<Td className="avatar-cell" column="status">
								<AvatarCell
									item={userItem}
									value={userItem.role}
								/>
							</Td>
							<Td className={className} column="name">
								{userItem.name ? userItem.name : ''}
							</Td>
							<Td className={className} column="email">
								{userItem.email ? userItem.email : ''}
							</Td>
							<Td className={className} column="customer">
								{customer ? customer.name : ''}
							</Td>
							<Td className={className} column="role">
								{userItem.role ? userItem.role : ''}
							</Td>
							{isAdmin ? (
								<Td className="list-cell align-center narrow" column="edit">
									<UserActionsCell
										item={userItem}
										editUser={this.props.editUser.bind(this)}
										deleteUser={this.props.deleteUser.bind(this)}
									/>
								</Td>
							) : (<Td></Td>)}
						</Tr>
					);
				})}
			</Table>

		);
	}
}



// WEBPACK FOOTER //
// ./js/components/UserList.js